export default __webpack_public_path__ + "static/media/asparago.a576d9fb.webp";